import { Box } from '@mui/material';
import React from 'react';
import UtilidadesForm from './UtilidadesForm';
import { SERVICES_DAG } from '../../../../../constants/categoryService';

function UtilidadesUsuario({ dataUser }) {
  return (
    <Box>
      <UtilidadesForm service={SERVICES_DAG.envios} title="Utilidades envios" dataUser={dataUser} />
      <UtilidadesForm service={SERVICES_DAG.empaques} title="Utilidades empaques" dataUser={dataUser} />
      <UtilidadesForm service={SERVICES_DAG.servicios} title="Utilidades servicios" dataUser={dataUser} />
      <UtilidadesForm service={SERVICES_DAG.recargas} title="Utilidades recargas" dataUser={dataUser} />
      <UtilidadesForm
        service={SERVICES_DAG.repartoMultimarca}
        title="Utilidades reparto multimarca"
        dataUser={dataUser}
      />
    </Box>
  );
}

export default UtilidadesUsuario;
